














import { Component, Prop, Vue } from 'vue-property-decorator';
import dateFns from 'date-fns';
import nb from 'date-fns/locale/nb';

@Component({})
export default class MainHeader extends Vue {

    private upcomingElex = [
        {
            title: 'Kommunevalg',
            date: new Date(2019, 8, 9, 21),
            confirmed: true,
        },
        {
            title: 'Stortingsvalg',
            date: new Date(2021, 8, 13, 21),
            confirmed: false,
        },
    ];

    private countdown = (elex: any): string => {
        const now = new Date();
        if (elex.confirmed) {
            return `${dateFns.distanceInWordsStrict(elex.date, now, {
                locale: nb,
                unit: 'd',
            })}`;
        } else {
            return `${dateFns.distanceInWordsStrict(elex.date, now, {
                locale: nb,
                unit: 'd',
            })}`;
        }
    }
}
